/**
 * Determines whether a value should be redacted based on its key.
 * The function performs a case-insensitive match on the key name to see if the,
 * key matches any of the provided regular expression keys to redact.
 * @param key - The key of the value to check for redaction.
 * @param keysToRedact - An array of strings or regular expressions representing the keys to redact.
 * @returns True if the value should be redacted, false otherwise.
 */ const shouldRedactKey = (key, keysToRedact)=>{
    // Convert the key to lowercase for case-insensitive matching
    const lowercaseKey = key.toLowerCase();
    // Check if any of the keys to redact match the lowercased key
    return keysToRedact.some((redactKey)=>typeof redactKey === 'string' ? lowercaseKey === redactKey.toLowerCase() : redactKey.test(lowercaseKey));
};

export { shouldRedactKey };
//# sourceMappingURL=shouldRedactKey.js.map
